module.exports = __webpack_public_path__ + "media/images/home/flipcard_teacher_blue-01acc38f4bc07aa1d5865597d86d340d.png";